var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    className: "social-link"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.5312 15.6279c0-8.0273-6.5039-14.5312-14.5312-14.5312S.4687 7.6006.4687 15.6279c0 7.2528 5.314 13.2645 12.2608 14.3555V19.8285H9.0381v-4.2006h3.6914v-3.2015c0-3.6416 2.168-5.6532 5.4885-5.6532 1.5902 0 3.2531.2836 3.2531.2836v3.5743h-1.8328c-1.8047 0-2.3678 1.1203-2.3678 2.2693v2.7275h4.0301l-.6445 4.2006h-3.3856v10.1549c6.9469-1.091 12.2607-7.1027 12.2607-14.3555Z"
  })));
};
export default SvgFacebook;